// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__jxQ8l","form":"styles_form__2SPz1"};